import React, { Component } from 'react';
import { findDOMNode, ReactDOM } from 'react-dom';
import classnames from 'classnames';
import { Tooltip } from '@platform/base';
// import { toast } from 'platform/old/2005'; // 有可能导致依赖循环
import HistoryRecord from '../SimpleTable/components/HistoryRecord';

import BaseTable, {
    TableStore,
    connect,
    useStore,
    useResize,
    useIndex,
    useCheckbox,
    useSort,
    useExpandRow,
    useTreeTable,
    useFilter,
    usePagination,
    useErrorTips,
    useRowClick,
    useLocation,
    useContextMenu,
    useCellSelect,
    useHotKey,
    useDOM,
    useGroupSort,
    useFieldSetting,
    useEditTable,
    useCache,
    useStyle,
    useOprCol,
    useAutoMerge,
} from "@platform/table-core";

import { WithKeyboardChange } from '@platform/base';
import { getAutoWrap } from '../../libs/useContextMenu';
import {
    handleBeforeEvent,
    handleAfterEvent,
    splitPks,
    setAutoWrap,
    isEmptyValue,
    getRowHeight,
} from '../utils';
import { getMultiLang, ViewModel, getGlobalStorage, getTopWindow, toast } from '@platform/api';
import { ROW_STATUS } from '../../utils';

const { EditTableWithKeyboardChange } = WithKeyboardChange;

let hookExtensions = [
    EditTableWithKeyboardChange,
    connect,
    useHotKey,
    useAutoMerge,
    useStore,
    useResize,
    useIndex,
    useCheckbox,
    useExpandRow,
    useRowClick,
    useTreeTable,
    useSort,
    useCellSelect,
    useDOM,
    useEditTable,
    usePagination,
    useCache,
    useFilter,
    useLocation,
    useContextMenu,
    useGroupSort,
    useFieldSetting,
    useStyle,
    // useCopy,
    useErrorTips,
    useOprCol,
];

const ComposedTable = hookExtensions.reduceRight((Table, HOC) => HOC(Table), BaseTable);

class EditTable extends Component {
    constructor(props) {
        super(props);
        this.state = { emptyTableData:[], searchTipVisible:false };
        this.emptyDataQuickAnimation = true;
        this.isListened = false;  
    }
    componentDidMount() {
        this.props.store.setRef(this);

        let { store, relationQuery } = this.props;

        getMultiLang({
            moduleId: "page_table",
            callback: json => {
                store.setLocale(json);
            },
        });

        this.useCache(); 
        this.getInitHistoryData(relationQuery);
    }
    componentWillReceiveProps (nextProps) {
        this.getInitHistoryData(nextProps.relationQuery);
    }
    getInitHistoryData = relationQuery => {
        let { pageScope, transformHistoryCard = data => data } = this.props;
        let { getUserQueryHistory } = pageScope.search;
        if(relationQuery && (!this.isListened || relationQuery !== this.props.relationQuery )) { //多个查询区共用一个表格，所以存在isListened为true的情况下也要更新
            //监听查询区的查询按钮
            pageScope.search.addEventListener(relationQuery, 'clickSearchBtn', this.getHistoryData, true);
            this.isListened = true;
            getUserQueryHistory({ areacode:relationQuery }).then(data => {
                this.setState({ emptyTableData:transformHistoryCard(data) });
            }); 
        } 
    }
    getHistoryData = () => {
        let { pageScope, relationQuery, transformHistoryCard = data => data } = this.props;
        let { getUserQueryHistory } = pageScope.search;
        //点击查询的时候，要先存数据，后取，取的时候用延时
        setTimeout(() => {
            this.emptyDataQuickAnimation = false;
            getUserQueryHistory({ areacode:relationQuery }).then(data => {
                this.setState({ emptyTableData:transformHistoryCard(data) });    
            });
        }, 200);  
    }
    render () {

        let {
                high_selectable,
                onCloseModel, // pass 侧拉点击关闭按钮时回调
                tableModelConfirm, // pass 侧拉点击确定按钮时回调
                tableModelConfirmText, // 侧拉点击确定按钮时的文本
                selectedChange, // p
                onSelectedAll, // p
                // setCellClass, // p
                onRowClick, //p
                onRowDoubleClick, //p
                onSelected, //p
                inputChange, // p
                rowClassList, // p
                showPagination, //p
                handlePageInfoChange, //p
                showCheck,
                showIndex,
                alloweFilter: enableFilter = true, // p
                multipleRowCell = false,
                onBatchSelected, // p
                onBatchChange,
                // onBeforeEvent, // p
                // onAfterEvent, // p
                hideRightMenu = false,
                extendRightMenu,
                extendRightMenuPlacement,
                handleFilterCallBack,
                handleResetCallBack,
                sort,
                isAddRow, //p
                addRowDefaultValue = {}, // p
                addRowCallback, // p
                noColSetClass,
                colSetCallback,
                showTotal,
                rightMenuClick,
                cancelCustomRightMenu = false, // true时，不显示右键菜单里的列表设置
                showWidthAndHeightConfig = true,
                height,
                adaptionHeight = true,
                fieldid,
                footer,
                id,
                store,
                crossPageSelect,
                pkname,
                pageScope,
                allowTotalRows,
                noTotalRows,
                noTotalCol,
                onTableCellClick,
                bodyStyle,
                isSort = true, // 开启排序
                addBlankCol,
                hiddenLeftItem,
                columnWidthConfig = true,
                fixFooter,
                scrollContainer,
                // addAffixScroll: fixFooter,
                mergeCell,
                lazyload = true,
                virtualHead,
                disableClickRowToSelect,
                setHeadClass,
                renderEmptyText, //领域-空状态文本
                renderExtendZone, //领域-空状态扩展区域
                relationQuery, //查询区ID
                emptyShowQuery, //是否显示空状态
                emptySearchCallBack, //空状态历史记录查询给领域的回调,
                historyCardLength = 4,
                hiddenDelRow,
                _runContext, //内部页签上下文参数
                customSetting = {}, //个性化设置参数
                rowHeight,
                hiddenFieldSetting, //排序筛选下拉箭头开关
                onContextMenu,
                enterDirection = 'right',
            } = this.props,
            config = store.getConfig(),
            { setCellClass, onBeforeEvent, onAfterEvent, preventAfterEventWhenBrowse } = config,
            useVirtual = true;

        /**
         * cancelCustomRightMenu=false / columnWidthConfig = true / extendRightMenu有值 / foldingRowChange有值时，需要有右键菜单
         * cancelCustomRightMenu=false时显示列设置图标
         */
        if(hideRightMenu){
            cancelCustomRightMenu = true;
        }

        let isLoadedMeta = store.getMeta() || {};
        //初始化
        if (config.multipleRowCell === true && getAutoWrap(store, id, true) === undefined && Object.keys(isLoadedMeta)?.length !== 0) {
            setAutoWrap(store, id, config.multipleRowCell);
        }

        height = bodyStyle?.height ?? height;

        let ncc_automated = getGlobalStorage('localStorage', '_ncc_automated_');
        if (ncc_automated == '1') {
            // 自动化测试开关打开
            useVirtual = false;
        }

        let fontClass = window?.nccFontSize || (window && getTopWindow()?.nccFontSize) || getGlobalStorage('localStorage', 'nccFontSize') || '';

        let shareIds = [];
        if(store.getGridTableId()){ // 入参id是表格id，看看是不是卡片表格的
            shareIds.push(store.getGridTableId());
        }
        let locale = store.getLocale();
        let { clearUserQueryHistory } = pageScope.search;
        return <ComposedTable
            id={id}
            currentId = {id}
            key={id}
            store={store}
            pageScope={pageScope}
            allowTotalRows={allowTotalRows}
            noTotalRows={noTotalRows}
            noTotalCol={noTotalCol}
            fixFooter={fixFooter}
            scrollContainer={scrollContainer}
            autoRowHeight={getAutoWrap(store, id)}
            bodyStyle={{
                maxHeight: (adaptionHeight || !bodyStyle?.maxHeight) ? undefined : bodyStyle.maxHeight,
                height: height || 300,
                minHeight: 60,
            }}
            setHeadClass={setHeadClass}
            addBlankCol={addBlankCol}
            flex={adaptionHeight}
            rowHeight={rowHeight || getRowHeight()}
            className="edit-table"
            defaultRenderStatus='edit'
            pkname={pkname}
            crossPageSelect={crossPageSelect}
            renderItems={pageScope.state.renderItem?.table?.[id] || {}}
            rowKey={row => row.key}
            indexConfig={{ enable: showIndex }}
            virtualConfig={{ x: useVirtual, y: !!lazyload, header: virtualHead }}
            checkboxConfig={{
                enable: showCheck,
                more: crossPageSelect && pkname && store.getStatus() !== 'edit',
                onCheck: (rowKey, { isChecked, checkedKeys, lastCheckedKeys }) => {
                    let visibleKeysLength = store.getVisibleRowKeys()?.length || 0;
                    shareIds.forEach(shareId => {
                        pageScope.editTableDataSource[shareId].setCheckedKeys(checkedKeys);
                    });
                    if(rowKey){ //单行改变
                        let row = store.getRowData(rowKey);
                        if (isChecked ) {
                            store.setClickedRow(row.key);
                        } 
                        // else {     //这行本来是为了修改NCC-353821， 但会引发NCC-362164
                        //     store.setClickedRow('');
                        // }
                        onSelected?.(
                            { ...pageScope.props, ...pageScope.output },
                            id,
                            row,
                            row.dataIndex,
                            isChecked,
                            //TODO isUnique
                        );
                    } else {
                        if (!isChecked) {
                            store.setClickedRow('');
                        }
                        onSelectedAll?.(
                            { ...pageScope.props, ...pageScope.output },
                            id,
                            !!checkedKeys?.size,
                            visibleKeysLength,
                        );
                    }

                    selectedChange?.({ ...pageScope.props, ...pageScope.output }, id, checkedKeys?.size || 0, lastCheckedKeys?.size || 0);
                },
            }}
            paginationConfig={{
                enable: showPagination && store.getStatus() !== 'edit',
                defaultPageSize: config.defaultPageSize,
                maxPageSize: config.maxPageSize,
                paginationExtendRender: config.paginationExtendRender,
                onChange: ({ pageIndex, pageSize }) => {
                    let allPks = store.getAllRowsInfo()?.allpks;
                    let pks = splitPks(allPks, pageIndex, pageSize);
                    handlePageInfoChange?.({ ...pageScope.output, ...pageScope.props }, config, pks, store.getPaginationInfo()?.total, { tableId: id });
                },
            }}
            fieldSettingConfig = {{ enable: !hiddenFieldSetting }}
            filterConfig={{
                enable: enableFilter,
                title: pageScope.state.meta?.[id]?.name || '',
                onFilter: handleFilterCallBack,
                onReset: handleResetCallBack,
            }}
            sortConfig={{
                enable: isSort,
                // onSort: orderMap => {
                //     let sortInfo = [...orderMap].map(([colKey, order], index) => {
                //         return {
                //             order: order === 1 ? "ascend" : "descend",
                //             field: colKey,
                //             orderNum: index,
                //         };
                //     });
                //     sort?.sortFun?.(sortInfo, store.getVisibleRows());
                // },
            }}
            locationConfig={{ enable: true }}
            cellSelectConfig={{
                enable: high_selectable?.enable ?? true,
                batchSelectEnable: !!onBatchChange,
                beforeSelect: high_selectable?.beforeClearData,
                onSelect: (selectedCell, { startCell, endCell, batchSelect, action }) => {
                    console.log('框选', selectedCell);

                    if (!startCell || !endCell || batchSelect) {
                        return;
                    }

                    // if (!selectedCell.size) {
                    //     // 清空
                    //     high_selectable?.beforeClearData?.();
                    // }

                    if (onBatchSelected) {
                        /**
                         * 传了这个参数，才勾选前面的行。以前的逻辑是这样的
                         * 如果选中的是单行，走onRowClick逻辑
                         * 否则这里设置选中
                         */
                        let selectedRows = store.getCheckedKeys();
                        store.setCheckedKeys(new Set([...selectedCell.keys()].concat(action === "ctrl" ? [...selectedRows] : [])));
                        // startCell.row.key !== endCell.row.key && store.setCheckedKeys(new Set([...selectedCell.keys()]));
                        // 单行onRowClick走不到这里，cellSelect那里已经阻断了
                        onBatchSelected(
                            {
                                ...pageScope.props,
                                ...pageScope.output,
                            },
                            id,
                            [...selectedCell].map(([rowKey]) => store.getRowData(rowKey)),
                        );
                    }
                },
                onChange: (selectedRows, { column, row, oldValues, texts, values }) => {
                    console.log('批改', selectedRows, column, row);

                    let colKey = column.key;

                    onBatchChange?.({
                        allData: store.getRows(),
                        areaCode: id,
                        changedrows: selectedRows.map((row, index) => {
                            return {
                                newvalue: { value: texts[index] },
                                oldvalue: oldValues[index],
                                rowid: row.key,
                            };
                        }),
                        column,
                        currentIndex: selectedRows[0].dataIndex,
                        newValue: selectedRows.map((row, index) => {
                            delete row.pasteErrorMsg; //错误提示清空
                            row = {
                                ...row,
                                values: {
                                    ...row.values,
                                    [colKey]: { value: texts[index] },
                                },
                            };
                            return row;
                        }),
                        pasteData: texts.map(e => typeof e === 'string' ? e.trim() : e),
                        values,
                    });

                    // selectedRows.forEach(row => {
                    //     store.setCellValue(row.key, column.key, { value: row.values[colKey] });
                    // });
                },
                exclude: high_selectable?.disabledColumn ?? [],
            }}
            cellProps={(rowInfo, colInfo) => {
                let props = {};
                if (typeof onTableCellClick === 'function') {
                    props.onClick = e => {
                        onTableCellClick(rowInfo.row, rowInfo.rowIndex/** viewIndex */, colInfo.col.key, colInfo.col, e);
                    };
                }
                if (typeof setCellClass === 'function') {
                    props.className = setCellClass(rowInfo.rowIndex/** viewIndex */, rowInfo.row, colInfo.col.key);
                }
                return props;
            }}
            rowProps={row => {
                let className = '',
                    dataIndex = row.dataIndex;

                if (Array.isArray(rowClassList)) {
                    className = rowClassList.filter(({ index }) => {
                        if (!Array.isArray(index)) {
                            index = [index];
                        }
                        return index.includes(dataIndex);
                    }).map(e => e.className).join(' ');
                } else if (typeof rowClassList === 'function') {
                    className = rowClassList(row, dataIndex);
                } else {
                    className = rowClassList;
                }

                return {
                    disableClickRowToSelect,
                    className,
                    onClick:  e => onRowClick?.({ ...pageScope.props, ...pageScope.output }, id, row, store.getRowData(row.key).dataIndex, e),
                    onDoubleClick: onRowDoubleClick && (e => onRowDoubleClick?.(row, store.getRowData(row.key).dataIndex, { ...pageScope.props, ...pageScope.output }, e)),
                };
            }}
            onBeforeEvent={({ value, event, colKey, rowKey }) => {
                console.log('EditTable表体编辑前事件', value, event, colKey, rowKey);

                let row = store.getRowData(rowKey),
                    column = store.getColumnProps(colKey);

                store.setCache('oldBatchData', { colKey, dataIndex: row.dataIndex });
                store.setClickedRow(rowKey);
                store.setCellProps(rowKey, colKey, { invalid: false });
                store.clearCellValidate(rowKey, colKey);

                return handleBeforeEvent.call(pageScope, {
                    row,
                    column,
                    value,
                    moduleId: id,
                    callback: () => {
                        return onBeforeEvent?.(
                            { ...pageScope.props, ...pageScope.output },
                            id,
                            column,
                            row.dataIndex,
                            value,
                            row,
                        );
                    },
                    type: 'onEditTableBeforeEvent',
                });
            }}
            onValueChange={(rowKey, { attrcode, value }) => {
            // 编辑中change回调 参考原代码
                let column = store.getColumnProps(attrcode),
                    row = store.getRowData(rowKey);
                // 为郭祉琪加的针对input类型时,这两个字段的特殊校验,换算率
                if (column.itemtype === 'input' && ['vchangerate', 'vqtunitrate'].includes(column.attrcode)) {
                // eslint-disable-next-line no-useless-escape
                    let reg = /^[0-9\/\.]+$/;
                    if (value && !reg.test(value)) { //只能输入数字和/
                        return;
                    }
                }
                //胡杰李忠博加
                if (typeof inputChange === 'function') {
                // 转换一下index
                    inputChange({ index: row.dataIndex, item: column, valueChange: value.value });
                }

                row.status === ROW_STATUS.ORIGIN && (row.status = ROW_STATUS.EDIT);
                store.setRowData({ ...row, value: { ...row.values, [attrcode]: value } });
            }}
            onAfterEvent={({ value, oldValue, componentValue, event, colKey, rowKey, formId }) => {
                console.log('EditTable表体编辑后事件', value, oldValue, componentValue, event, colKey, rowKey);

                let row = store.getRowData(rowKey),
                    column = store.getColumnProps(colKey),
                    visibleRows = store.getVisibleRows();

                // Item统一处理trim
                // typeof value?.value === 'string' && (value.value = value.value.trim());

                if (column.itemtype === "residtxt") {
                    // 多语文本value格式不一样，要特殊处理一下
                    [...Object.entries(value), [colKey, value[colKey]]].forEach(([subCode, subValue]) => {
                        // 同步单来源的值
                        store.setCellValue(rowKey, subCode, { value: subValue });
                    });
                } else {
                    store.setCellValue(rowKey, colKey, { value });
                }

                // 自动增行的处理 是最后一行 & 编辑态 & 当前单元格不为空 & 多语字段的值会进一步判断 这里先判断其他条件
                if(isAddRow && (value?.value || column.itemtype === "residtxt") && row.viewIndex === visibleRows.length - 1 && store.getStatus() === 'edit'){
                    let validateValue = value.value;
                    let switchBrowser = column.itemtype === 'switch_browse' && column.disabled; // 是开关，且不可编辑

                    // 特殊类型的值获取 TODO
                    if(column.itemtype === 'residtxt'){
                        validateValue = value;
                    } else if(column.itemtype === 'refer') {
                        validateValue = componentValue;
                    }

                    if(!switchBrowser && !isEmptyValue(validateValue, column.itemtype)){
                        if(addRowDefaultValue instanceof Promise){
                            addRowDefaultValue.then(rowValues => {
                                store.addRow(visibleRows.length, { values: rowValues }, { autoFocus: false, rowKey: pkname });

                                visibleRows = store.getVisibleRows();
                                addRowCallback?.(store.getVisibleRows()[visibleRows.length - 1]);
                            });
                        } else {
                            addRowDefaultValue = typeof addRowDefaultValue === 'function' ? (addRowDefaultValue() ?? {}) : JSON.parse(JSON.stringify(addRowDefaultValue));
                            store.addRow(visibleRows.length, { values: addRowDefaultValue }, { autoFocus: false, rowKey: pkname });

                            visibleRows = store.getVisibleRows();
                            addRowCallback?.(store.getVisibleRows()[visibleRows.length - 1]);
                        }
                    }
                }

                // 触发业务编辑后
                handleAfterEvent.call(pageScope, {
                    row: store.getRowData(rowKey),
                    column: store.getColumnProps(colKey),
                    value,
                    oldValue,
                    componentValue,
                    moduleId: id,
                    callback: ({ changedRows }) => {
                        // handleAfterEvent里更新了数据，这里要同步
                        row = store.getRowData(row.key);
                        if(preventAfterEventWhenBrowse && store.getStatus == "browse") {
                            return;
                        }
                        return onAfterEvent?.(
                            {
                                ...pageScope.props,
                                ...pageScope.output,
                            },
                            id,
                            colKey,
                            // 特殊类型值的返回
                            column.itemtype === 'refer' || column.itemtype === 'residtxt' ? componentValue : value.value,
                            changedRows,
                            row.dataIndex,
                            row,
                            '', // isTriggerModal
                            '', // triggerType
                            event,
                        );
                    },
                    type: 'onEditTableAfterEvent',
                    store,
                    formId,
                });
            }}
            totalConfig={{ enable: showTotal }}
            contextMenuConfig={{
                enable: !hideRightMenu && (high_selectable?.enable ?? true) && (high_selectable?.selectCell ?? true),
                hiddenDelRow,
                extendRightMenu,
                extendRightMenuPlacement,
                rightMenuClick,
                cancelCustomRightMenu,
                showWidthAndHeightConfig,
                hiddenLeftItem,
                columnWidthConfig,
                disableArea: (rowKey, colKey) => {
                    if(!noColSetClass) {return false;}
                    let cellClass = store.getCellProps(rowKey, colKey, 'className');
                    return cellClass?.includes(noColSetClass);
                },
                onColSetting: () => {
                    colSetCallback?.();
                },
                onClick: key => {
                    pageScope.forceUpdate();
                    store.forceUpdate();
                    onContextMenu?.(key);
                },
            }}
            modalConfig={{
                onClose: record => onCloseModel?.call(pageScope, { ...pageScope.props, ...pageScope.output }, id, record),
                onSure: record => tableModelConfirm?.call(pageScope, { ...pageScope.props, ...pageScope.output }, id, record),
                confirmText: tableModelConfirmText,
            }}
            renderEmptyArea = {(wrapperHeight = 550) => { //渲染表格空状态
                if(!emptyShowQuery) {
                    return; 
                } 
                let { search } = this.props.pageScope;
                let { executeSearch } = search;
                let emptyTableData = this.state.emptyTableData.slice(0, historyCardLength);
                let isEmptyData = !emptyTableData?.length;
                let containerClass = '';
                let height = 520 ;
                let hasExtendZone = typeof renderExtendZone === "function";
                // 空状态布局
                if(wrapperHeight >= 550) {
                    height = 520;
                } else if ( wrapperHeight >= 430 && wrapperHeight < 550 ) {
                    height = 420;
                } else if ( wrapperHeight >= 390 && wrapperHeight < 430 ) {
                    height = '95%';
                    containerClass = 'empty-table-three';
                } else if (wrapperHeight >= 300 && wrapperHeight < 390){
                    height = '95%';
                    containerClass = 'empty-table-four'; 
                }else if (wrapperHeight >= 220 && wrapperHeight < 300){ 
                    containerClass = 'empty-table-five';
                    height = '95%';
                } else {
                    containerClass = 'empty-table-five';
                    height = 205;
                }
                return <div 
                    className = {classnames(
                        {
                            "empty-table-container": true,
                            [containerClass]: true,
                            'has-extend-zone': hasExtendZone,
                        },
                    )}
                    style={{ height:height }}
                >
                    <div className='empty-wrapper-top'>
                        <div className='top-left'>
                            <div className='top-left-background' ></div>
                        </div>
                        <div className='top-right'>
                            <div className='empty-text' fieldid='empty-table-text'>
                                {renderEmptyText?.() || locale['table0054'] /*暂无数据*/} 
                            </div>
                            <div className='empty-extend-zone'>
                                {renderExtendZone?.()} 
                            </div>
                        </div>   
                    </div>
                    <div className= {classnames({
                        'history-quick-animation':this.emptyDataQuickAnimation,
                        'empty-wrapper-bottom':true, 
                        'empty-wrapper-bottom-show':!isEmptyData, 
                    },
                    )}>
                        <div className='recent-search-title'>
                            <span className="hr hr-left"></span>
                            <p>{locale['table_recent_search']/*记录近期使用过的查询结果*/}</p>
                            <Tooltip placement="top" 
                                overlay={locale['table_clear_search']}
                                visible = {this.state.searchTipVisible}
                            >
                                <i 
                                    className={`iconfont icon-qingkongnew clear ${isEmptyData ? 'disable-clear' : ''}`} 
                                    onClick={() => {
                                        if(isEmptyData) { //没有历史记录时
                                            return;
                                        }
                                        clearUserQueryHistory({ areacode:relationQuery }).then(() => {
                                            this.emptyDataQuickAnimation = false;
                                            this.setState({ emptyTableData:[] });
                                            toast({ content:locale['table_clear_success']/*清除历史记录成功*/, color:'success' });
                                        }).catch(() => {
                                            toast({ content:locale['table_clear_warning']/*清除历史记录失败*/, color:'warning' });
                                        });
                                    }
                                    }
                                    onMouseEnter={() => this.setState({ searchTipVisible:true })}
                                    onMouseOut={() => this.setState({ searchTipVisible:false })}
                                ></i>
                            </Tooltip>
                            <span className="hr hr-right"></span>
                           
                        </div>
                        <div className='history-card-wrapper'>
                            {
                                emptyTableData.map( query => {
                                    let { querycondition = {}, recordtime, pk_queryhistory, searchFlag, queryrelationinfo } = query;
                                    let { conditions = [] } = querycondition;
                                    return <HistoryRecord
                                        key={pk_queryhistory}
                                        records={conditions}
                                        emptySearchCallBack={emptySearchCallBack}
                                        searchTime = {recordtime}
                                        wrapperWidth = {ReactDOM?.findDOMNode(this)?.querySelector('.history-card-wrapper')?.clientWidth}
                                        isDisabled = {!searchFlag}
                                        queryrelationinfo = {queryrelationinfo}
                                        locale = {locale}
                                        onSearch = {() => executeSearch(relationQuery, query)}
                                    />;
                                }) 
                            } 
                        </div> 
                    </div> 
                </div>;
            }}
            fieldid={fieldid}
            mergeCell={mergeCell}
            fontClass={fontClass}
            _runContext={_runContext}
            footer={footer} 
            customSetting = {customSetting}
            hotkeyConfig={{ enterDirection }}
        />;
    }

    componentDidUpdate() {
        this.useCache();

        // 客开的旧版本钩子兼容,没有客开时不会执行客开方法
        let { store, pageScope } = this.props;
        let data = store?.getRows() || [];
    }

    componentWillUnmount() {
        let { dataSource, store, pkname, pageScope, relationQuery, _runContext } = this.props;

        if (dataSource) {
            let pageInfo = store.getPaginationInfo(),
                rows = store.getRows(),
                { allpks } = store.getAllRowsInfo(),
                filterInfo = store.getFilterInfo(),
                checkedInfo = store.getCheckedInfo(),
                lastClickedRow = store.getClickedRow(),
                sortInfo = store.getSortInfo(),
                visibleColumns = store.getVisibleColumns(),
                visibleRows = store.getVisibleRows(),
                meta = store.getMeta(),
                currentpks = visibleRows.map(row => row.values[pkname]?.value).filter(e => e),
                { pageIndex, pageSize } = pageInfo;

            allpks = allpks ? [...allpks] : [];
  
            let cacheAllPks = [...allpks];
            allpks.splice(Number(pageIndex) * Number(pageSize), pageSize, ...currentpks);
            
            // 附件列
            let attachmentCols = [];
            visibleColumns.forEach(col => {
                if(col.itemtype === "attachment") {
                    attachmentCols.push(col);
                }
            });
            let pkFormMeta = meta.metaJson?.head?.pk; 
             
            let data = {
                simpleTable:{
                    rows: rows,
                    currentpks, // 当页的pk
                    allpks,
                    cacheAllPks,
                    pageInfo,
                    scrollTop: findDOMNode(this).querySelector('.vertical-scroll-bar').scrollTop,
                    checkedInfo,
                    filterInfo,
                    sortInfo,
                    pkname:pkname || pkFormMeta,
                    lastClickedRow,
                    attachmentCols,
                },
            };

            ViewModel.setData(dataSource, data, _runContext);
        }
         
        relationQuery && this.isListened && pageScope.search.removeEventListener(relationQuery, 'clickSearchBtn', this.getHistoryData.callbackId);
        this.isListened = false;
        this.props.store.removeRef(this);
    }

    useCache = () => {
        let { dataSource, store, _runContext = {} } = this.props,
            columns = store.getColumns(),
            { componentInitFinished } = store.getConfig() || {};

        if (dataSource && !this.cached && columns.length) {
            this.cached = true;

            let cache = ViewModel.getData(dataSource, _runContext)?.simpleTable,
                storeCache = {}; // 给cancelEdit用，YBP-MM-BUG-748

            if (!cache) {return;}

            if (cache.pageInfo) {
                store.setPaginationInfo(cache.pageInfo);
                storeCache = {
                    ...storeCache,
                    ...cache.pageInfo,
                };
            }

            if (cache.rows) {
                store.setRows({ rows: cache.rows });
                storeCache.rows = cache.rows;
            }

            if (cache.cacheAllPks) {
                store.setAllRowsInfo({ allpks: cache.cacheAllPks });
                storeCache.allpks = cache.cacheAllPks;
            }

            if (cache.scrollTop && cache.rows.length) {
                this.scroll(cache.scrollTop);
            }

            if (cache.lastClickedRow) {
                store.setClickedRow(cache.lastClickedRow);
            }

            // if (cache.currentpks) {

            // }

            if(cache.checkedInfo) {
                store.setCheckedInfo(cache.checkedInfo);
            }

            if(cache.filterInfo){
                store.setFilterInfo(cache.filterInfo);
            }

            if(cache.sortInfo){
                store.setSortInfo(cache.sortInfo);
            }

            store.setCache('base', storeCache);

            componentInitFinished?.();
        }
    }

    scroll = scrollTop => {
        requestAnimationFrame(() => {
            if (findDOMNode(this).querySelectorAll('.table-next-body tr:not(.empty-table)').length) {
                findDOMNode(this).querySelector('.vertical-scroll-bar').scrollTop = scrollTop;
            } else {
                scroll(scrollTop);
            }
        });
    }
}

EditTable.displayName = 'EditTable';
EditTable.useEditTable = function () {
    let store = new TableStore(hookExtensions);
    return store.getAllHooks();
};

export default EditTable;
